let scrollPositionTop = window.scrollY,
    lastScrollTop = 0,
    scrollTimeout = null, 
    headerSticky = document.querySelector('.site-header'),
    button = document.querySelector('.switch'),
    isScrolling;


//Fixed navbar after 500px 
window.addEventListener('scroll', function(){
    scrollPositionTop = window.scrollY;
    headerSticky.classList.add('is-fixed');
    if(scrollPositionTop >= 200){
        headerSticky.classList.add('scroll-fixed')
    } else {
        headerSticky.classList.remove('scroll-fixed');
    }
})

// //Fixed navbar after 500px 
// window.addEventListener('scroll', function(){
//     scrollPositionTop = window.scrollY;

//     if(localStorage.getItem('menu') != 'sticky'){
//         headerSticky.classList.add('is-fixed');
//         if(scrollPositionTop >= 200){
//             headerSticky.classList.add('scroll-fixed')
//         } else {
//             headerSticky.classList.remove('scroll-fixed');
//         }
//     } else {
//         headerSticky.classList.remove('is-fixed');
//         headerSticky.classList.remove('scroll-fixed');
//     }
// })

// //Scroll up effect
// window.addEventListener('scroll', function(){

//     if(!headerSticky.classList.contains('is-scroll-up')){
//         return;
//     }

//     if(scrollPositionTop >= 200){
//         headerSticky.classList.add('scroll-fixed')
//     } else {
//         headerSticky.classList.remove('scroll-fixed');
//     }
    
//     if(localStorage.getItem('menu') == 'sticky' && headerSticky.classList.contains('is-scroll-up')){
//         let st = window.pageYOffset || document.documentElement.scrollTop;

//         if (st > lastScrollTop){
//            // downscroll code
//             headerSticky.classList.remove('sticky');
//             headerSticky.classList.add('stickyOff');

//         } else if ((st - lastScrollTop) < -15) {
//            // upscroll code
//             headerSticky.classList.add('sticky');
//             headerSticky.classList.remove('stickyOff');
//         }
//         lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
//     }

// }, false)



// if(localStorage.getItem('menu') == 'sticky'){
//     headerSticky.classList.add('is-scroll-up');
//     document.getElementById('toggleSticky').checked = true;
// } else {
//     headerSticky.classList.remove('is-scroll-up');
//     headerSticky.classList.remove('stickyOff');
//     headerSticky.classList.remove('sticky');
// }

// button.addEventListener('click', function(){
//     if(document.getElementById('toggleSticky').checked){
//          localStorage.setItem('menu', 'sticky');
//          headerSticky.classList.add('is-scroll-up');
//     } else {
//          localStorage.removeItem('menu');
//          headerSticky.classList.remove('is-scroll-up');
//          headerSticky.classList.remove('stickyOff');
//          headerSticky.classList.remove('sticky');
//     }
// })

 
